export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://docs.microsoft.com/en-us/exchange/policy-and-compliance/mailbox-audit-logging/enable-or-disable';
